import { render } from "./DocumentNavigationSignee.vue?vue&type=template&id=48f816f9&scoped=true"
import script from "./DocumentNavigationSignee.vue?vue&type=script&lang=js"
export * from "./DocumentNavigationSignee.vue?vue&type=script&lang=js"

import "./DocumentNavigationSignee.vue?vue&type=style&index=0&id=48f816f9&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f816f9"]])

export default __exports__